import { Container, styled, Pagination } from '@mui/material';
import { IApiCallStatus, ValueLabel, variables } from '../common';
import { renderStack, IRequestStatus } from '.';

export function RequestStatusStack({
  properties,
  requests,
  getRequstsCallStatus,
  selectedRequestIds,
  disableOperationsHelpDsk,
  toggleRequestSelection,
  confirmCancelRequests,
}: {
  properties: ValueLabel<keyof IRequestStatus>[];
  requests: IRequestStatus[];
  getRequstsCallStatus: IApiCallStatus;
  selectedRequestIds?: number[];
  disableOperationsHelpDsk: boolean;
  toggleRequestSelection?: (payload: IRequestStatus) => void;
  confirmCancelRequests?: () => void;
}) {
  const s = Paginatio;
  switch (getRequstsCallStatus) {
    case null:
      return <Container maxWidth="lg">Loading...</Container>;

    case false:
      return <Container maxWidth="lg">Error</Container>;

    case true:
      return renderStack(
        s,
        disableOperationsHelpDsk,
        selectedRequestIds,
        toggleRequestSelection,
        confirmCancelRequests
      )(properties)(requests);

    case void 0:
      return null;

    default:
      return <Container maxWidth="lg">Idk</Container>;
  }
}

const Paginatio = styled(Pagination)(({ theme }) => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',

    '&>*+*': {
      marginTop: '0.5rem',
    },
  },

  itemWrapper: {
    paddingBottom: '0.5rem',
    borderBottom: variables.cardBorder,
  },

  line: {
    '&>*+*': {
      marginLeft: '1rem',
    },
  },

  label: {
    fontWeight: 700,
  },
}));
